import { render } from "./new-course.vue?vue&type=template&id=e8a465d4&scoped=true"
import script from "./new-course.vue?vue&type=script&lang=js"
export * from "./new-course.vue?vue&type=script&lang=js"

import "./new-course.vue?vue&type=style&index=0&id=e8a465d4&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a465d4"]])

export default __exports__